import { Chapter } from "@/data/bookOfComfort";
import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";

interface BookChapterProps {
  chapter: Chapter;
  darkMode?: boolean;
}

const BookChapter = ({ chapter, darkMode = false }: BookChapterProps) => {
  return (
    <section
      id={`chapter-${chapter.id}`}
      className="mb-16 scroll-mt-24"
    >
      {/* Chapter Header */}
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="text-sm font-semibold text-[#006B5F] uppercase tracking-wide">
            Chapter {chapter.id}
          </span>
          <div className={cn(
            "flex items-center gap-1 text-xs",
            darkMode ? "text-gray-400" : "text-gray-500"
          )}>
            <Clock className="w-3 h-3" />
            <span>{chapter.readingTime} min read</span>
          </div>
        </div>
        <h2 className={cn(
          "text-2xl md:text-3xl font-bold leading-tight",
          darkMode ? "text-white" : "text-gray-900"
        )}>
          {chapter.title}
        </h2>
      </div>

      {/* Chapter Content */}
      <div className="prose prose-lg max-w-none mb-8">
        {chapter.content.split('\n\n').map((paragraph, index) => (
          <p key={index} className={cn(
            "mb-4 leading-relaxed",
            darkMode ? "text-gray-300" : "text-gray-700"
          )}>
            {paragraph}
          </p>
        ))}
      </div>

      {/* Prayer Section */}
      <div className={cn(
        "rounded-lg p-6 border-l-4 border-[#006B5F]",
        darkMode
          ? "bg-gradient-to-br from-[#006B5F]/20 to-[#006B5F]/30"
          : "bg-gradient-to-br from-[#006B5F]/5 to-[#006B5F]/10"
      )}>
        <h3 className="text-lg font-semibold text-[#006B5F] mb-3">Prayer</h3>
        <p className={cn(
          "italic leading-relaxed",
          darkMode ? "text-gray-300" : "text-gray-700"
        )}>
          {chapter.prayer}
        </p>
      </div>
    </section>
  );
};

export default BookChapter;

